import req from '@/utils/request';

// 获取设备状态
export const getStatus = (params) => {
  return req.voiceGet('/status', params);
}
//关闭
export const stop = (params) => {
  return req.voicePost('/stop', params);
}
//开启
export const start = (params) => {
  return req.voicePost('/start', params);
}

//获取智能病例
export const getIntelligentCase = (params) => {
  return req.post('/aimatrix/doctor-assist/med-rec', params);
}

//埋点
export const track = (params) => {
  return req.post('/data-track/useful-med', params,'/aimatrix');
}

//获取设备版本
export const getVersion = (params,config) => {
  return req.voiceGet('/version', params,config);
}